import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import axiosInstance from "../../config/axiosInterceptor";

const RechargeHistory = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [filterType, setFilterType] = useState("all");
  const [search, setSearch] = useState("");
  const getDefaultStartDate = () => {
    const today = new Date();
    return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-01`;
  };

  const getDefaultEndDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };

  const [startDate, setStartDate] = useState(getDefaultStartDate());
  const [endDate, setEndDate] = useState(getDefaultEndDate());
  const [total, setTotal] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [adminrechargeHistory, setAdminrechargeHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchRechargeHistory = async () => {
    try {
      setLoading(true);

      let url = `${process.env.REACT_APP_BASEURL1}/admin/recharge/getrechargeHistory?page=${currentPage}&limit=${entriesPerPage}`;
      if (filterType === "users") url += `&type=2`;
      else if (filterType === "coin") url += `&type=1`;
      if (search) url += `&search=${search}`;
      if (startDate) url += `&startDate=${startDate}T00:00:00`;
      if (endDate) url += `&endDate=${endDate}T23:59:59`;

      const { data } = await axiosInstance.get(url);
      setAdminrechargeHistory(data.data);
      setTotal(data.total);
      setTotalAmount(data.totalAmount || 0);
      setLoading(false);
    } catch (e) {
      toast.error(e.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRechargeHistory();
  }, [currentPage, entriesPerPage]);

  const totalPages = Math.ceil(total / entriesPerPage);

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const startPage = Math.max(1, currentPage - 2);
    const endPage = Math.min(totalPages, currentPage + 2);

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <li key={i} className={`page-item ${currentPage === i ? "active" : ""}`}>
          <button onClick={() => setCurrentPage(i)} className="page-link">
            {i}
          </button>
        </li>
      );
    }

    return pageNumbers;
  };

  const submitHandler = async (dataDetails) => {
    try {
      const { data } = await axiosInstance.post(
        `${process.env.REACT_APP_BASEURL5}/admin/return/coins`,
        dataDetails
      );
      if (data.success === "1") {
        toast.success(data.message);
        fetchRechargeHistory();
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <>
      <section className="content-header">
        <h1>Recharge History</h1>
        <ol className="breadcrumb">
          <li>
            <Link to="/admin">
              <i className="fa fa-dashboard"></i> Home
            </Link>
          </li>
          <li className="active">Recharge History</li>
        </ol>
      </section>

      <section className="content">
        <div className="row" style={{ padding: "16px 0px" }}>
          <div className="col-md-2">
            <label>Filter Type:</label>
            <select
              value={filterType}
              onChange={(e) => {
                setFilterType(e.target.value);
                setCurrentPage(1);
              }}
              className="form-control"
            >
              <option value="all">All</option>
              <option value="users">Users</option>
              <option value="coin">Coin Agency</option>
            </select>
          </div>

          <div className="col-md-2">
            <label>Start Date:</label>
            <input
              type="date"
              className="form-control"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>

          <div className="col-md-2">
            <label>End Date:</label>
            <input
              type="date"
              className="form-control"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>

          <div className="col-md-2">
            <label>Search:</label>
            <input
              type="text"
              className="form-control"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search"
            />
          </div>

          <div className="col-md-2">
            <label>&nbsp;</label>
            <button className="btn btn-primary form-control" onClick={fetchRechargeHistory}>
              Apply Filter
            </button>
          </div>

          <div className="col-md-2 text-right">
            <label>Total:</label>
            <div><b>Entries:</b> {total}</div>
            <div><b>Amount:</b> {totalAmount}</div>
          </div>
        </div>

        <div className="row" style={{ marginBottom: "10px" }}>
          <div className="col-md-3">
            <label>Entries per page:</label>
            <select
              className="form-control"
              value={entriesPerPage}
              onChange={(e) => {
                setEntriesPerPage(parseInt(e.target.value));
                setCurrentPage(1);
              }}
            >
              <option value="10">10</option>
              <option value="50">50</option>
              <option value="200">200</option>
              <option value="500">500</option>
            </select>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <div className="box">
              <div className="box-body">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>Sr.</th>
                      <th>Image</th>
                      <th>To</th>
                      <th>Username</th>
                      <th>Coin</th>
                      <th>Date/Time</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="7" className="text-center">Loading...</td>
                      </tr>
                    ) : (
                      adminrechargeHistory?.map((item, index) => (
                        <tr key={item._id}>
                          <td>{(currentPage - 1) * entriesPerPage + index + 1}</td>
                          <td>
                            <img
                              src={`${process.env.REACT_APP_BASEURL}${item.image}`}
                              style={{ height: "70px", width: "70px", borderRadius: "50%" }}
                              alt="User"
                            />
                          </td>
                          <td>{item.to === 2 ? "User" : "Coin Agency"}</td>
                          <td>{item.userId}</td>
                          <td>
                            <label className="label label-success">{item.coin}</label>
                          </td>
                          <td>{new Date(item.createdAt).toLocaleString()}</td>
                          <td>
                            <button
                              style={{
                                backgroundColor: "red",
                                color: "white",
                                fontWeight: "bold",
                                border: "none",
                                padding: ".3rem .5rem",
                              }}
                              onClick={() => {
                                const res = window.confirm("Are you sure you want to return coin?");
                                if (res) submitHandler({ id: item._id });
                              }}
                            >
                              Return
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>

                <div className="row">
                  <div className="col-md-6">
                    <ul className="pagination">
                      <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                        <button
                          onClick={() => setCurrentPage(currentPage - 1)}
                          className="page-link"
                          disabled={currentPage === 1}
                        >
                          Previous
                        </button>
                      </li>
                      {renderPageNumbers()}
                      <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                        <button
                          onClick={() => setCurrentPage(currentPage + 1)}
                          className="page-link"
                          disabled={currentPage === totalPages}
                        >
                          Next
                        </button>
                      </li>
                    </ul>
                  </div>

                  <div className="col-md-6 text-right" style={{ marginTop: "20px" }}>
                    Total entries: <b>{total}</b>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default RechargeHistory;
